import { apiSlice } from "../stores/base/api-slice";

export interface ZohoSaleConfiguration {
	tenantId: string;
	widgetCode: string;
}

const zohoSaleEndpoints = apiSlice.injectEndpoints({
	endpoints: builder => ({
		// widgetCode is the tenant's SalesIQ `wc` value; UtilityId is resolved
		// server-side from the authenticated customer's HttpContext.
		getZohoSaleConfiguration: builder.query<ZohoSaleConfiguration, void>({
			query: () => ({
				url: "/customersupportservice/zoho-sale-configuration",
				method: "GET",
			}),
		}),
	}),
});

export const { useGetZohoSaleConfigurationQuery } = zohoSaleEndpoints;
